import { AuthGuard, CrudOp, fakomAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { useRequiredProjectParam, useRequiredSubprojectParam } from "@org-avp/avp-avengers-ui-shared-store";
import { importView } from "@org-avp/avp-avengers-ui-shared-utils";
import { FC, lazy, Suspense } from "react";

export const MaterialInfoView: FC = () => {
  const projectId = useRequiredProjectParam("projectId");
  const subprojectId = useRequiredSubprojectParam("subprojectId");
  const modelYear = useRequiredSubprojectParam("modelYear", (modelYear) => parseInt(modelYear));
  return (
    <AuthGuard authScope={fakomAuthScope} crudOp={CrudOp.READ} project={projectId}>
      <Suspense><LazyMaterialInfoView projectId={projectId} subprojectId={subprojectId} modelYear={modelYear}/></Suspense>
    </AuthGuard>
  );
};

const LazyMaterialInfoView = lazy(importView(
  () => import("../components/MaterialInfoView"),
  (it) => it.MaterialInfoView,
));
